import Http from '@/libs/http';

class SMSApi extends Http {
    send(params) {
        return super.post(`portal/sms`, params);
    }
}

export default new SMSApi();
